import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Grid, Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import { useForm } from '../../../hooks/useForm';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ValidatedDatePicker from '../../compartidos/ValidatedDatePicker';
import { useDispatch } from 'react-redux';
import { conveniosAumento } from '../../../actions/contrataciones/contratacionesConvenios';

const AumentoButton = () => {
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();

    const initialValues = {
        porcentaje: "",
        fechaInicioVigencia: null,
        redondeo: false
    };

    const [
        formValues,
        handleInputChange,
        resetForm,
        setearValor,
    ] = useForm(initialValues);

    const { porcentaje, fechaInicioVigencia, redondeo } = formValues;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(conveniosAumento(formValues, () => {
            handleClose()
            resetForm()
        }));
    }

    return (
        <>
            <Button
                color="primary"
                onClick={handleClickOpen}
                variant="contained"
            >% Aumento</Button>
            {
                open &&
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xs"
                    fullWidth
                >
                    <ValidatorForm onSubmit={handleSubmit}>
                        <DialogTitle id="alert-dialog-title">{"Aumento por porcentaje"}</DialogTitle>
                        <DialogContent>
                            <Grid container>
                                <Grid item xs={12}>
                                    <MuiPickersUtilsProvider
                                        locale={esLocale}
                                        utils={DateFnsUtils}
                                    >
                                        <ValidatedDatePicker
                                            fullWidth={true}
                                            label="Fecha Inicio Vigencia"
                                            format="dd/MM/yyyy"
                                            // minDate={moment(new Date())}
                                            okLabel="Aceptar"
                                            clearLabel="Limpiar"
                                            cancelLabel="Cancelar"
                                            name="fechaInicioVigencia"
                                            value={
                                                moment(fechaInicioVigencia).isValid()
                                                    ? moment(fechaInicioVigencia)
                                                    : null
                                            }
                                            onChange={(e) => setearValor("fechaInicioVigencia", e)}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                            validators={[
                                                "required",
                                            ]}
                                            errorMessages={[
                                                "La fecha de inicio de vigencia es requerida",]}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextValidator
                                        label="Valor %"
                                        margin="normal"
                                        fullWidth
                                        autoComplete="off"
                                        value={porcentaje}
                                        name='porcentaje'
                                        onChange={handleInputChange}
                                        validators={['required', "isFloat"]}
                                        errorMessages={["El valor es requerido", "Solo numeros"]}
                                    />
                                </Grid>
                                <Grid item sm={1} style={{ alignSelf: 'center' }}>
                                    <FormControl
                                        fullWidth={true}
                                        margin="normal"
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="redondeo"
                                                    checked={redondeo}
                                                    onChange={(e) => setearValor("redondeo", !redondeo)}
                                                />
                                            }
                                            label="Redondeo"
                                        />
                                    </FormControl>
                                </Grid>

                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button type="button" onClick={handleClose} color="primary">
                                Cancelar
                            </Button>
                            <Button type="submit" color="primary" autoFocus>
                                Aceptar
                            </Button>
                        </DialogActions>
                    </ValidatorForm>
                </Dialog>
            }
        </>
    )
}

export default AumentoButton
